module.exports = __webpack_public_path__ + "static/kv2-2093254648e7761fa4396110648a67ef.jpg";